(function() {
  const sizeChartTab = document.querySelector('#size-chart-tab');
  if(window.structuredData){
    if(sizeChartTab){
      sizeChartTab.innerHTML = `
        <div class="nili-modal-content__inner">
            <div class="nili-size-unit-conversion pt-3">
                <a href="#" class="btn btn--nili-size-guide-in nili-btn-clicked">Inches</a>
                <a href="#" class="btn btn--nili-size-guide-cm">Centimeters</a>
            </div>
            <div id="nili-table"></div>
            <div class="footer-text-field"></div>
        </div>
      `;
    }

    const openButtons = document.querySelectorAll('.nili-openButton');
    const closeButton = document.querySelector('.nili-close');    
    const modal = document.querySelector('.nili-modal');
    const body = document.body;

    function isModalOpen() {
        return modal.style.display === 'block';
    }

    openButtons.forEach(function(openButton) {
      openButton.addEventListener('click', (event) => {
        event.stopPropagation();
        if (isModalOpen()) {
          closeModal();
        } else {
          openModal();
        }
      });
    });

    function openModal() {
      modal.style.display = 'block';
      modal.setAttribute('aria-hidden', 'false');
      body.classList.add('no-scroll');
      setTimeout(() => {
        modal.classList.add('nili-modal--show');
        closeButton.focus();
      }, 100);
    }

    function closeModal() {
      modal.classList.remove('nili-modal--show');
      setTimeout(() => {
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        body.classList.remove('no-scroll');
        if (openButtons.length > 0) {
          openButtons[0].focus();
        }
      }, 300);
    }

    document.addEventListener('DOMContentLoaded', (event) => {
      closeButton.addEventListener('click', () => {
          closeModal();
      });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });

    body.addEventListener('click', (event) => {
      if (modal.classList.contains('nili-modal--show') && !modal.contains(event.target)) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isModalOpen()) {
            closeModal();
        }
    });
  
    modal.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
  
        let focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        let firstElement = focusableElements[0];
        let lastElement = focusableElements[focusableElements.length - 1];
  
        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
        }
    });
  
    var spanElement = document.querySelector('.nili-size-guide-name');
    if (spanElement) {
      spanElement.textContent = sizeChartName;
    } else {
      console.error("'nili-size-guide-name' not found.");
    }
  
    var niliTable = document.getElementById("nili-table");
    var table = document.createElement("table");
    var tableCaptionElement = document.createElement("caption");
    var tableCaption = document.getElementById('sizeGuideTitle').textContent.trim() + " " + "in inches/centimeters";
    tableCaption = tableCaption.toUpperCase();
    var thead = document.createElement("thead");
    var headerRow = document.createElement("tr");

    tableCaptionElement.textContent = tableCaption;
    tableCaptionElement.classList.add("visually-hidden");
    table.appendChild(tableCaptionElement);
  
    table.setAttribute("summary", "This table provides " + 
      document.getElementById('sizeGuideTitle').textContent
          .trim()
          .replace(/measurements/i, '') 
          .trim() 
      + " measurements in inches and centimeters.");
      
    var labelsCount = {};
    for (var label in structuredData) {
      var th = document.createElement("th");
      th.textContent = label;
      headerRow.appendChild(th);
      th.setAttribute("scope", "col");
      var normalizedLabel = label.toLowerCase().replace(/\b\d+\b/g, '').replace(/\s+/g, ' ').trim();
      var cleanID = label
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .map(function(word, index) {
        return index == 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
      labelsCount[normalizedLabel] = (labelsCount[normalizedLabel] || 0) + 1;
      if (labelsCount[normalizedLabel] > 1) {
        th.setAttribute("id", cleanID + "-" + labelsCount[normalizedLabel]);
      } else {
        th.setAttribute("id", cleanID);
      }
    }
    
  
    thead.appendChild(headerRow);
    var tbody = document.createElement("tbody");
    var labelsCount = {};
    for (var i = 0; i < Object.values(structuredData)[0].length; i++) {
      var row = document.createElement("tr");
      var isHeader = true;
      var theaderID1 = "";
  
      for (var label in structuredData) {
        var thElement = document.createElement("th");
        var tdElement = document.createElement("td");
        var cell = isHeader ? thElement : tdElement;
        cell.textContent = structuredData[label][i];

        var theaderID2 = label
        .replace(/[^\w\s]|[\d]/gi, '')
        .split(' ')
        .map(function(word, index) {
          if (index == 0) {
            return word.toLowerCase();
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          }
        })
        .join('');

        if (!isHeader) {
          // cell.classList.add("nili-table-value");
          // var spanNumeric = document.createElement("span");
          // spanNumeric.classList.add("nili-table-value__numeric");
          // const inches = parseFloat(structuredData[label][i]);
          // const centimeters = inches * 2.54;
          // let toInches = Math.round(inches * 10) / 10;
          // spanNumeric.textContent = toInches.toString();
          // spanNumeric.setAttribute("data-size-value", inches.toString());
          // spanNumeric.setAttribute("data-size-value-cm", centimeters.toFixed(2));
      
          // var spanUnit = document.createElement("span");
          // spanUnit.classList.add("nili-table-value__unit");
          // spanUnit.textContent = "”";
          // cell.textContent = '';
          // cell.appendChild(spanNumeric);
          // cell.appendChild(spanUnit);

          cell.classList.add("nili-table-value");
          var spanNumeric = document.createElement("span");
          spanNumeric.classList.add("nili-table-value__numeric");

          var rawValue = structuredData[label][i];
          var isLocked = rawValue.toString().trim().endsWith('*');
          var cleanValue = isLocked ? rawValue.toString().trim().slice(0, -1) : rawValue;

          // Always display without the *
          spanNumeric.textContent = cleanValue;

          if (!isLocked) {
            // Only set conversion attributes if not locked
            const inches = parseFloat(cleanValue);
            const centimeters = inches * 2.54;
            let toInches = Math.round(inches * 10) / 10;

            spanNumeric.textContent = toInches.toString();
            spanNumeric.setAttribute("data-size-value", inches.toString());
            spanNumeric.setAttribute("data-size-value-cm", centimeters.toFixed(2));
          } else {
            // Mark locked values for later checks
            spanNumeric.setAttribute("data-locked", "true");
          }

          var spanUnit = document.createElement("span");
          spanUnit.classList.add("nili-table-value__unit");
          spanUnit.textContent = isLocked ? "" : "”";

          cell.textContent = '';
          cell.appendChild(spanNumeric);
          cell.appendChild(spanUnit);
        }else {
          thElement.setAttribute("scope", "row");
          var cleanID = cell.textContent.replace(/\s+/g, '').replace(/\./g, '_');
          labelsCount[cleanID] = (labelsCount[cleanID] || 0) + 1;
          if (labelsCount[cleanID] > 1) {
            theaderID1 = theaderID2 + "-" + cleanID + "-" + labelsCount[cleanID];
          } else {
            theaderID1 = theaderID2 + "-" + cleanID;
          }
          thElement.setAttribute("id", theaderID1);
          thElement.setAttribute("headers", theaderID2);
        }
    
        tdElement.setAttribute("headers", theaderID1 + " " + theaderID2);

        row.appendChild(cell);
        isHeader = false;
      }
      tbody.appendChild(row);
    }
  
    table.appendChild(thead);
    table.appendChild(tbody);
    niliTable.appendChild(table);
  
    let currentUnit = "inches";
    const inchesBtn = document.querySelector(".btn--nili-size-guide-in");
    const centimetersBtn = document.querySelector(".btn--nili-size-guide-cm");
  
    inchesBtn.addEventListener("click", convertToInches);
    centimetersBtn.addEventListener("click", convertToCentimeters);
  
    function convertToCentimeters(event) {
      event.preventDefault();
      if (currentUnit === "inches") {
        const numericElements = document.querySelectorAll('.nili-table-value__numeric');
        numericElements.forEach(element => {
          if (element.hasAttribute('data-size-value')) {
            const inches = parseFloat(element.getAttribute('data-size-value'));
            const centimeters = Math.round(inches * 2.54);
            element.textContent = centimeters;

            // Update only this element’s unit
            if (element.nextElementSibling) {
              element.nextElementSibling.textContent = " cm";
            }
          }
        });

        centimetersBtn.classList.add("nili-btn-clicked");
        inchesBtn.classList.remove("nili-btn-clicked");
        currentUnit = "cm";
      }
    }
  
    function convertToInches(event) {
      event.preventDefault();
      if (currentUnit === "cm") {
        const numericElements = document.querySelectorAll('.nili-table-value__numeric');
        numericElements.forEach(element => {
          if (element.hasAttribute('data-size-value-cm')) {
            const centimeters = parseFloat(element.getAttribute('data-size-value-cm'));
            let inches = centimeters / 2.54;
            inches = Math.round(inches * 10) / 10;
            element.textContent = inches.toString();

            // Update only this element’s unit
            if (element.nextElementSibling) {
              element.nextElementSibling.textContent = "”";
            }
          }
        });

        inchesBtn.classList.add("nili-btn-clicked");
        centimetersBtn.classList.remove("nili-btn-clicked");
        currentUnit = "inches";
      }
    }

    var footerTextField = document.querySelector('.footer-text-field');
    if (footerTextField && window.footerText) {
      footerTextField.innerHTML = window.footerText;
    }
  }

})();

(function() {
  function applyGroupHeaders() {
    const table = document.querySelector('#nili-table table');
    const totalColumns = table.querySelector('tr').cells.length;
    const headerRow = table.createTHead().insertRow(0);

    let nextColIndex = 1;

    window.sizeChartGroupHeaders.forEach(headerDefinition => {
        const [headerName, range, color] = headerDefinition.split(', ');
        const [startCol, endCol] = range.split('-').map(Number);
        const colSpan = endCol - startCol + 1;

        if (startCol > nextColIndex) {
            const gapColSpan = startCol - nextColIndex;
            const emptyTh = document.createElement('th');
            emptyTh.colSpan = gapColSpan;
            emptyTh.setAttribute("id", "empty-header");
            headerRow.appendChild(emptyTh);
        }

        const headerTh = document.createElement('th');
        headerTh.className = "group-header";
        headerTh.colSpan = colSpan;
        headerTh.textContent = headerName;
        headerTh.style.backgroundColor = color;
        headerTh.style.width = `${100 * colSpan}px`;
        headerRow.appendChild(headerTh);
        var cleanID = headerName
        .replace(/[^\w\s]|[\d]/gi, '')
        .split(' ')
        .map(function(word, index) {
          if (index == 0) {
            return word.toLowerCase();
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          }
        }).join('');
        headerTh.setAttribute("id", cleanID);

        nextColIndex = endCol + 1;

        Array.from(table.querySelectorAll('thead tr, tbody tr')).forEach((row, index) => {
          if (row.closest('thead') && index === 0) {
            window.headerTexts = [];
            Array.from(row.cells).forEach((cell) => {
              if (!cell.classList.contains("group-header")) {
                cell.setAttribute("role", "presentation");
              }else{
                cell.setAttribute("scope", "col");
              }
              const colspan = cell.colSpan > 1 ? cell.colSpan : 1;
              const headerId = cell.textContent.trim().replace(/[^\w\s]|[\d]/gi, '')
              .split(' ').map(function(word, index) {
                if (index == 0) {
                  return word.toLowerCase();
                } else {
                  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                }
              }).join('');
              const headerContent = headerId;
              for (let i = 0; i < colspan; i++) {
                  window.headerTexts.push(headerContent);
              }
            });
          }
    
          if (row.closest('thead') && index === 1) {
            let currentHeaderIndex = 0;
            Array.from(row.cells).forEach((cell, colIndex) => {
              const headerText = window.headerTexts[currentHeaderIndex];
              if(headerText){
                cell.setAttribute("headers", headerText);
              }else{
                cell.removeAttribute("headers");
              }
              currentHeaderIndex += (cell.colSpan > 1 ? cell.colSpan : 1);
            });
          }

          if (row.closest('tbody')) {
            let currentHeaderIndex = 0;
            Array.from(row.cells).forEach((cell) => {
              const existingHeaders = cell.getAttribute("headers") || "";
              const headerText = window.headerTexts[currentHeaderIndex];
              if (headerText) {
                const headersList = existingHeaders.split(" ");
                if (!headersList.includes(headerText)) {
                    const newHeaders = `${existingHeaders} ${headerText}`.trim();
                    cell.setAttribute("headers", newHeaders);
                }
              }
              currentHeaderIndex += (cell.colSpan > 1 ? cell.colSpan : 1);
            });
          }
        
        for (let col = startCol - 1; col < endCol; col++) {
          if (row.cells[col]) {
            row.cells[col].style.backgroundColor = color;            
          }
        }
      });
      
    });

    if (nextColIndex <= totalColumns) {
        const remainingColSpan = totalColumns - nextColIndex + 1;
        const remainingTh = document.createElement('th');
        remainingTh.colSpan = remainingColSpan;
        remainingTh.setAttribute("role", "presentation");
        remainingTh.setAttribute("id", "empty-header-2");
        headerRow.appendChild(remainingTh);
    }
  }
  
  if(window.sizeChartGroupHeaders){
    applyGroupHeaders();
  }

})();